<template>
  <div class="current-action" :class="{visible: currentActionMessage}">
    <div v-show="currentActionMessage" class="message shadow" v-html="currentActionMessage">
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'current-action',
    data () {
      return {}
    },
    computed: {
      ...mapState('queue', ['queue', 'isWorking', 'currentActionMessage'])
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .current-action {
    color: rgba(245, 245, 245, .8);
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 1rem;
    opacity: 0;
    transition: all 0.2s ease-in-out;
    .message {
      background-color: rgba(42, 51, 62, 1);
      padding: 1rem;
    }
    &.visible {
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// CurrentAction.vue?02cab936